import { render, staticRenderFns } from "./JobArchivedFormSubmissions.vue?vue&type=template&id=722fd3d2&"
import script from "./JobArchivedFormSubmissions.vue?vue&type=script&lang=js&"
export * from "./JobArchivedFormSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports